import { useEffect, useState } from "react";

import { getAvailableFunds } from "../../../services/investor.service";
import { useEffectAsync } from "../../../utils/hooks/useEffectAsync.hook";
import { FundItem } from "../../../utils/types/fund.type";
import { Fund } from "../../../utils/types/investor.type";

export const useFundsListEffect = () => {
  const [fundList, setFundList] = useState<FundItem[]>([]);

  useEffectAsync(
    async (isCanceled) => {
      const responseFundList: any = await getAvailableFunds();

      if (isCanceled()) return;

      setFundList([...responseFundList]);
    },
    []
  );
  return { fundList };
};

export const useUpdateFundsListEffect = (
  investorFundList: Fund[] = [],
  FundsList: FundItem[] = [],
) => {
  const [checkFundList, setCheckFundList] = useState<FundItem[]>([]);
  const investorFundIds = investorFundList.map(m => m.id);
  
  useEffect(() => {
    const checkList = FundsList.map((fund) => {
      return {
        ...fund,
        isChecked: investorFundList
          ? investorFundIds.includes(fund.id)
          : false,
      };
    });

    setCheckFundList([...checkList]);
  }, [FundsList, investorFundList]);
  return { checkFundList, setCheckFundList };
};
